export function useNavigationFixedState(ioHeader: IOHeaderSettings) {
  // const fixed = ref(false)
  // const mini = ref(false)

  const { ww } = useWindow()
  const { y } = useWindowScroll()

  const { $io } = useNuxtApp()


  let fixedTriggerHeight = ref(0)
  
  if(ioHeader.headerFixedTriggerType === 'value') {
    fixedTriggerHeight.value = ioHeader.headerFixedTriggerHeight;
  } else if(ioHeader.headerFixedTriggerType === 'element') {
    // 1 pixel for now
    const element = document.querySelector(ioHeader.headerFixedTriggerElementSelector)
    if(element && element instanceof HTMLElement) {
      fixedTriggerHeight.value = element.offsetHeight
    } else {
      throw new Error('headerFixedTriggerElementSelector | Element not found')
    }
  } else {
    throw new Error('Invalid headerFixedTriggerType')
  }

  // Header Fixed State
  watch(y, (value) => {
    if (value > fixedTriggerHeight.value) {

      // Mini and fixed are separate states
      $io.headerFixed = true

      // Mini and fixed are separate states
      // if (value > miniTriggerHeight.value)
      //   $io.headerFixed = true
      // else
      //   $io.headerFixed = false

    } else {
      $io.headerFixed = false
    }
  }, {
    immediate: true,
  })
  

  // Depending on the page, the fixed state can be customised, for example, the hero page
  // For now it is just fixed when the user starts scrolling beyond the hero section
  function init() {
    // The init function should be changes via watchers responsible for the page, 
    // If nothing is provided, the default is the fixed state should be used
  }

  return {
    // init,
    // fixed,
    // mini,
  }
}